export const homeContent = {
    courses: [
      {
        id: 1,
        title: "From Zero to Hero",
        title2: "Beginner Group Class 🌱",
        description: "Small group class (4 pax) perfect for beginners. Learn Hangeul, daily conversations, and speak Korean confidently by practicing with more than 6 different real-life situations.",
        image: "/assets/south-korea-background-white.jpg",
        duration: "5 weeks",
        level: "Beginner",
      },
      {
        id: 2,
        title: "Level Up Your Korean",
        title2: "Private 1:1 Beginner Class 🌟",
        description: "Personalized Korean learning experience for Beginners ready to expand their vocabulary and speaking skills.",
        image: "/assets/korea-background_low_res.jpg",
        duration: "5 weeks",
        level: "Beginner",
      },
      {
        id: 3,
        title: "Level Up Your Korean",
  title2: "Private 1:1 Upper Beginner Class ✈️",
        description: "Personalized Korean learning experience for Upper Beginners ready to expand their vocabulary, grammar, and speaking skills.",
        image: "/assets/korea-skytower.jpg",
        duration: "5 weeks",
        level: "Upper Beginner",
      },
    ],
    
    telegram: {
      title: "Join Our Learning Community 💬",
      description: "Connect with 200+ fellow Korean learners! Get FREE learning materials, practice tips, and encouragement from your 선생님 and classmates.",
      link: "https://t.me/+Gh66v3hBE_MwYWM9",
    },
    team: [
      {
        img: '/assets/aisyah.png',
        name: "Aisyah",
        role: "Co-Founder & 선생님",
        bio: "Your caring Korean teacher who believes every student can succeed! With years of experience, I create a safe space where mistakes become stepping stones to fluency."
      },
      {
        img: '/assets/syasya.png',
        name: "Syasya",
        role: "Co-Founder & 선생님",
        bio: "Your enthusiastic Korean learning cheerleader! I love crafting engaging lessons that make grammar fun and help you connect with Korean culture authentically."
      }
    ],
  
    testimonials: [
      { text: '"Great learning experience! The tutors are amazing."', author: "Sophia R." },
      { text: '"I learned so much in just a few weeks!"', author: "Michael D." },
      { text: '"The classes are engaging and fun!"', author: "Emily T." }
    ],
    about: {
      text: "안녕하세요! Welcome to AALC - where Korean dreams become reality! 🌟 We're your passionate 선생님 duo, bridging Malaysian hearts with Korean culture through engaging, structured learning. With over 7 years of teaching excellence, we empower every student to speak Korean confidently in our warm, supportive community."
    }
  };